export default __webpack_public_path__ + "static/media/worldColour.5400x2700.322bf4cc.jpg";